// removed by extract-text-webpack-plugin
module.exports = {"NameCell":"NameCell--2zzTR","AdminIcon":"AdminIcon--21t01"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Pages/Division/DivisionGrid.scss
// module id = 944
// module chunks = 1